import type * as ecModels from '../../../models'
import * as plugin from '../../plugin'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import * as extraReducers from './extra-reducers'
import { Selectors } from './selectors'
import { State } from './state'

// TODO: ents.core.common.Attribute<string> should provide generic type through entity collection

/**
 * Manages attributes of the entities in the entity collection
 */
export class Plugin<
  TTypeParams extends ecModels.TypeParams.Constraint,
> extends plugin.Plugin<
  TTypeParams,
  plugin.Plugin.Id.Standard.Attribute,
  State<TTypeParams>,
  Selectors<TTypeParams>,
  ReturnType<typeof getActionsConfig<TTypeParams>>
> {
  constructor({ collection }: Plugin.constructor.Params<TTypeParams>) {
    super({
      actions: getActionsConfig<TTypeParams>(),
      collection,
      id: plugin.Plugin.Id.Standard.Attribute,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })
    this.feature.registerExtraReducers(
      extraReducers.resetOnContextChange(collection),
      extraReducers.inferAttributesOnGetOrList(collection),
    )
    this.feature.registerEffects(
      effects.executeGetAttributes(collection),
      effects.eagerlyRequestAttributes(collection),
    )
  }
}
export namespace Plugin {
  export namespace constructor {
    export type Params<TTypeParams extends ecModels.TypeParams.Constraint> =
      Pick<plugin.Plugin.Default<TTypeParams>, 'collection'>
  }
}
